import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SubdomainDto, Subdomain } from '../../models/domain';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env';

@Injectable({
  providedIn: 'root'
})
export class SubdomainService {
  private readonly http = inject(HttpClient);

  addSubdomain(domainId: number, subdomainDto: SubdomainDto): Observable<Subdomain> {
    const url = `${environment.apiPrefix}/domains/${domainId}/subdomains`;
    return this.http.post<Subdomain>(url, subdomainDto);
  }

  deleteSubdomain(domainId: number, subdomainId: number): Observable<any> {
    const url = `${environment.apiPrefix}/domains/${domainId}/subdomains/${subdomainId}`;
    return this.http.delete(url);
  }

  editSubdomain(domainId: number, subdomainId: number, updateDto: SubdomainDto): Observable<Subdomain> {
    const url = `${environment.apiPrefix}/domains/${domainId}/subdomains/${subdomainId}`;
    return this.http.put<Subdomain>(url, updateDto);
  }

  updateSubdomainsOrder(domainId: number, subdomainIds: number[]): Observable<any> {
    const sortingUrl = `${environment.apiPrefix}/domains/${domainId}/subdomains/sorting`;
    return this.http.put(sortingUrl, subdomainIds);
  }
}
